import * as Accordion from '@radix-ui/react-accordion';
import Image from 'next/image';
import { Text, Flex, Icon, Button } from '@pairy/pds-react';

import { logo } from '@/components/User/_components/pdf/BulkLogos/index.constants';
import { TriggerChevronIcon } from '@/styles/Accordion/ViewHistoryAccordion.styles';

import * as OutterStyled from '../../index.styles';
import useCopy from '../../useCopy';

import * as Styled from './index.styles';

const HubSpot = () => {
  const copy = useCopy();

  return (
    <>
      <Accordion.Header>
        <OutterStyled.AccordionTrigger>
          <Image
            src={logo.hubspot.src}
            alt={logo.hubspot.alt}
            width={logo.hubspot.width}
            height={logo.hubspot.height}
          />
          <TriggerChevronIcon icon="ph:caret-up" size={19} />
        </OutterStyled.AccordionTrigger>
      </Accordion.Header>
      <OutterStyled.AccordionContent>
        <OutterStyled.Ol>
          <OutterStyled.Li>
            <Flex>
              <Flex
                as="button"
                display="inline-flex"
                onClick={() => copy('hubspot')}
              >
                <Icon icon="ph:link" size={17} color="skyblue_400" />
                <Text
                  as="p"
                  variant="md-medium"
                  color="skyblue_400"
                  marginLeft={4}
                >
                  HubSpot용 링크
                </Text>
              </Flex>
              <Text as="div" variant="md-medium" marginLeft={4}>
                복사한 뒤, 이메일 창에서
              </Text>
            </Flex>
          </OutterStyled.Li>
          <OutterStyled.Li>
            <Flex as="button" onClick={() => copy('hubspot')}>
              <Flex>
                <Styled.LinkIcon icon="ph:link-simple-horizontal" size={17} />
                <Text as="div" variant="md-medium" marginLeft={4}>
                  (Insert link) 또는 버튼에 삽입하기
                </Text>
              </Flex>
            </Flex>
          </OutterStyled.Li>
        </OutterStyled.Ol>

        <Button
          type="button"
          width="100%"
          variant="skyblue_300"
          textVariant="md-medium"
          radius={8}
          paddingX={16}
          paddingY={12}
          InnerWrappeGap={4}
          marginTop={16}
          leftIcon={<Icon icon="ph:link" size={17} />}
          onClick={() => copy('hubspot')}
        >
          HubSpot용 링크 생성하기
        </Button>
      </OutterStyled.AccordionContent>
    </>
  );
};

export default HubSpot;
